import React from 'react';
import { REPORT_DEFINITIONS } from '../../config/report-definitions';
import type { ReportType } from '../../types/report.types';
import { ReportCard } from './ReportCard';

interface ReportCardsGridProps {
  onGenerate: (type: ReportType, title: string) => void;
  countryCode?: string;
}

const AU_ONLY_TYPES: ReportType[] = ['tax_deduction', 'year_end_tax_summary'];

export function ReportCardsGrid({
  onGenerate,
  countryCode = 'AU',
}: ReportCardsGridProps): React.ReactElement {
  return (
    <section aria-label="Report types" className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
      {REPORT_DEFINITIONS.map((def) => {
        const auOnly = AU_ONLY_TYPES.includes(def.type);
        const disabled = auOnly && countryCode !== 'AU';
        return (
          <ReportCard
            key={def.type}
            definition={def}
            disabled={disabled}
            disabledReason={
              disabled
                ? 'This report uses Australian tax themes and is available when your profile country is Australia.'
                : undefined
            }
            onGenerate={() => onGenerate(def.type, def.title)}
          />
        );
      })}
    </section>
  );
}
